import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function ParamsTypography(props: { to: string, text: string }) {
    return <Link to={props.to} component={RouterLink} variant="body1">{props.text}</Link>
}